module.exports = __webpack_public_path__ + "img/tos.69185d9b.png";